import * as React from "react";
const SvgUpload = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.1667 14.1666H14.175M13 11.6666H15C15.7766 11.6666 16.1649 11.6666 16.4711 11.7935C16.8795 11.9626 17.204 12.2871 17.3731 12.6954C17.5 13.0017 17.5 13.39 17.5 14.1666C17.5 14.9432 17.5 15.3314 17.3731 15.6377C17.204 16.0461 16.8795 16.3706 16.4711 16.5397C16.1649 16.6666 15.7766 16.6666 15 16.6666H5C4.22343 16.6666 3.83515 16.6666 3.52886 16.5397C3.12048 16.3706 2.79602 16.0461 2.62687 15.6377C2.5 15.3314 2.5 14.9432 2.5 14.1666C2.5 13.39 2.5 13.0017 2.62687 12.6954C2.79602 12.2871 3.12048 11.9626 3.52886 11.7935C3.83515 11.6666 4.22343 11.6666 5 11.6666H7M10 12.4999V3.33325M10 3.33325L12.5 5.83325M10 3.33325L7.5 5.83325",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgUpload;
